export { default } from './component';


// WEBPACK FOOTER //
// ./components/Agile/team/index.js